import React from "react";

const Header = ({setResult}) => {
  return (
    <header className="py-6 bg-gray-600 ">
      <h1 className="text-center text-white text-4xl font-bold">
        <button href="#" onClick={()=> {setResult(false)}} className="focus:outline-none">春秋古筮法</button>
      </h1>
    </header>
  );
};

export default Header;
